import { render, staticRenderFns } from "./imageCode.vue?vue&type=template&id=0fd51605&scoped=true&"
import script from "./imageCode.vue?vue&type=script&lang=ts&"
export * from "./imageCode.vue?vue&type=script&lang=ts&"
import style0 from "./imageCode.vue?vue&type=style&index=0&id=0fd51605&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd51605",
  null
  
)

export default component.exports